import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  useTheme,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import dayjs from 'dayjs';

const formatTime = (time) => dayjs(time).format('HH:mm');

const ClinicTiming = ({ data }) => {
  const theme = useTheme();

  const EmptyState = () => (
    <Card elevation={3} sx={{ mb: 4, backgroundColor: theme.palette.gery.white }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={1}>
          <CalendarTodayIcon
            fontSize="small"
            sx={{ mr: 1, color: theme.palette.action.purpleLight }}
          />
          <Typography variant="h3" color="text.primary">
            Clinic Timings
          </Typography>
        </Box>
        <Typography variant="smallRegular" color="text.secondary">
          No timings available.
        </Typography>
      </CardContent>
    </Card>
  );

  if (!data || data.length === 0) return <EmptyState />;

  return (
    <Card elevation={3} sx={{ mb: 4, backgroundColor: theme.palette.gery.white }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <CalendarTodayIcon
            fontSize="small"
            sx={{ mr: 1, color: theme.palette.action.purpleLight }}
          />
          <Typography variant="h3" color="text.primary">
            Clinic Timings
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {data.map((timing, idx) => (
            <Grid item xs={12} key={idx}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={1.5}
                borderRadius={2}
                bgcolor={theme.palette.gery.lighter}
              >
                <Typography
                  variant="smallMedium"
                  color="text.primary"
                  textTransform="capitalize"
                >
                  {timing.day}
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <AccessTimeIcon
                    fontSize="small"
                    sx={{ color: theme.palette.icon }}
                  />
                  <Typography variant="smallRegular" color="text.secondary">
                    {formatTime(timing.startTime)} - {formatTime(timing.endTime)}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ClinicTiming;
